<template>

    <add
        :post-uri="route('api.v1.images.post')"
    ></add>

</template>

<script>

    import Add from "../../components/Images/Add";

    export default {

        components: {
            Add,
        },

        metaInfo: {
            title:'Add images',
        },

        name:'ImagesAdd',

    }

</script>
